import React from "react";
import styles from "./index.module.css";
import { FaLocationDot, FaUser } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const EntitySection = ({ entityName, origin, }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles["patient-transport__data-container-title"]}>
        <FaUser color="#2C4861" size={22} />
        <label className={styles["patient-transport__data-label"]}>
          {entityName}
        </label>
      </div>

      <div className={styles["patient-transport__data-container-title"]}>
        <FaLocationDot color="#2C4861" size={22} />
        <label className={styles["patient-transport__data-label"]}>
          {t("Pickup Location")}
        </label>
      </div>
      <div className={styles["patient-transport__data-container--location"]}>
        <label
          className={
            styles["patient-transport__data-container--location__area"]
          }
        >
          {origin?.area?.name}
        </label>
        <label
          className={
            styles["patient-transport__data-container--location__building"]
          }
        >{`${origin?.floor?.name}, ${origin?.building?.name}`}</label>
      </div>
    </>
  );
};

export default EntitySection;
